<template>
  <div style="background-color: #FFFFFF;">
    <div class="headers-view">
      <el-menu router background-color="#FFFFFF" text-color="#69696E"
               :default-active="activeUrl" class="el-menu-demo"
               mode="horizontal" @select="handleSelect" style="display: table;margin: 0 auto;">
        <el-menu-item index="/index">首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">医院概况</template>
          <el-menu-item align="center" index="/centerOverview/hospitalIntroduction">医院简介</el-menu-item>
          <el-menu-item align="center" index="/centerOverview/culturalConstruction">医院荣誉</el-menu-item>
<!--          <el-menu-item align="center" index="/centerOverview/incumbentLeader">领导班子</el-menu-item>-->
          <!--<el-menu-item align="center" index="/centerOverview/contactInformation">联系我们</el-menu-item>-->
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">新闻动态</template>
          <el-menu-item align="center" index="/newsInformation/hospitalNews">医院新闻</el-menu-item>
          <el-menu-item align="center" index="/newsInformation/medicalDisclosure">院务公开</el-menu-item>
          <el-menu-item align="center" index="/newsInformation/stopNotification">职工文化</el-menu-item>
          <el-menu-item align="center" index="/newsInformation/videoList">精彩视频</el-menu-item>
          <el-menu-item align="center" index="/newsInformation/jkkpList">健康科普</el-menu-item>
          <el-menu-item align="center" index="/newsInformation/gyhdList">公益活动</el-menu-item>
        </el-submenu>
        <el-menu-item index="/gzwj/gzwjIndex">规章文件</el-menu-item>
        <el-menu-item index="/columnList/partyWork">党建工作</el-menu-item>
        <el-menu-item index="/department/knowledge">专科知识</el-menu-item>
        <el-submenu index="4">
          <template slot="title">科室导航</template>
          <el-menu-item index="/department/doctors">专家简介</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="currentName" index="/news/newsRelease">新闻发布</el-menu-item>
        <el-menu-item index="/centerOverview/contactInformation">联系我们</el-menu-item>
        <!--<el-menu-item index="/table/index">出诊信息</el-menu-item>-->
        <!--<el-menu-item index="/columnList/nursingGarden">护理园地</el-menu-item>-->
        <!--<el-menu-item index="/columnList/disciplineInspection">纪检监察</el-menu-item>-->
        <!-- <el-menu-item index="/columnList/publicHealth">公共卫生</el-menu-item>-->
      </el-menu>
    </div>
    <img v-if="$route.path == '/index'" width="100%" src="./../../assets/img/newIndex/index.webp">
    <div id="backToTop" class="back_top" @click="backTop">
      <img src="~@/assets/img/index/back_top.png" height="50" width="50"/>
    </div>
  </div>
</template>

<script>
  import getters from "@/store/getters";

  export default {
    name: "HeaderView",
    data() {
      return {
        activeIndex: '1',
      }
    },
    props: {
      routes: {
        type: Array
      }
    },
    methods: {
      navClick(index) {
        this.navIndex = index;
        document.cookie = "navIndex=" + index + ";";
        this.$emit("appStyle", index);
      },
      handleSelect(key, keyPath) {
        // console.log(key, keyPath);
      },
      scrollFun(){
        window.onscroll = function() {
          const btn = document.getElementById('backToTop');
          if (document.documentElement.scrollTop > 600) {
            btn.style.display = 'block';
          } else {
            btn.style.display = 'none';
          }
        }
      },
      backTop(){
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    computed: {
      activeUrl() {
        //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：

        return this.$store.getters.getActiveUrl;
      },
      // 获取登录用户信息
      currentName() {
        //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：
        return sessionStorage.getItem("username")
      },
    },
    mounted() {
      this.scrollFun();
    }
  }
</script>

<style lang="scss">

  .headers-view {
    width: 1200px;
    margin: 0 auto;
  }

  .back_top {
    position: fixed;
    bottom: 150px;
    right: 50px;
    overflow: hidden;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    display: none;

    img {
      filter: brightness(100%);
    }

    img:hover {
      filter: brightness(75%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/headerView/HeaderView.vue